import React, { useCallback, useEffect } from 'react';
import { Container } from '@mui/material';
import { useParams, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { MetaTags } from '../../components/Metatags/Metatags';
import { loadingEventsSelector, selectedEventDetailsSelector, similarEventsSelector } from './selector';
import { EventContainer } from '../../components/ScreenContainer/EventContainer/EventContainer';
import { getEventsDetails } from '../../redux/events/action';
import { Spinner } from '../../components/Loading/Spinner';

const EventDetails = () => {
    const params = useParams();
    const [searchParams] = useSearchParams();
    const event = useSelector(selectedEventDetailsSelector);
    const similarEvents = useSelector(similarEventsSelector);
    const loading = useSelector(loadingEventsSelector);
    const query = Object.fromEntries([...searchParams]);
    const dispatch = useDispatch();
    const { eventId } = params;

    const handleGetAudition = useCallback(() => {
        if (eventId) {
            dispatch(
                getEventsDetails({
                    slug: eventId,
                    params: !!query && query.search ? '?search=true' : '',
                }),
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eventId, dispatch]);

    useEffect(() => {
        handleGetAudition();
    }, [handleGetAudition]);

    return (
        <MetaTags title={`Event | ${event?.name!}`} description={event?.description!}>
            <Container>
                {loading ? <Spinner /> : event && <EventContainer event={event} similarEvents={similarEvents} />}
            </Container>
        </MetaTags>
    );
};

export { EventDetails };
